import { render, staticRenderFns } from "./page-404.vue?vue&type=template&id=3bdfb39e&"
import script from "./page-404.vue?vue&type=script&lang=js&"
export * from "./page-404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports